var Statuses;
(function (Statuses) {
  Statuses["Completed"] = 'completed';
  Statuses["InProgress"] = 'in-progress';
  Statuses["NotStarted"] = 'not-started';
})(Statuses || (Statuses = {}));
var DefaultStatusLabels;
(function (DefaultStatusLabels) {
  DefaultStatusLabels["Completed"] = 'Status: Completed';
  DefaultStatusLabels["InProgress"] = 'Status: In Progress';
  DefaultStatusLabels["NotStarted"] = 'Status: Not Started';
})(DefaultStatusLabels || (DefaultStatusLabels = {}));
export { DefaultStatusLabels, Statuses };